module.exports = __webpack_public_path__ + "static/media/BSC.f85eaacb.svg";